import '../bootstrap';
import Cookies from 'js-cookie';
import './auth';
import './subscription';
import './claim-school';
import './school_register';

window.Cookies = Cookies;

window.defaultIntlTelInput = {
    separateDialCode: true,
    preferredCountries: ["in"],
    excludeCountries: ["am", "az", "ge", "de", "id", "kz", "kg", "ua", "uz", "tj"],
    autoPlaceholder: "Enter Mobile Number",
};

window.mainApiAxios = axios.create({
    baseURL: APP_API_URL,
});


